import { Combobox, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { FaChevronDown, FaFeather } from "react-icons/fa";
import stringToColor from "string-to-color";
import { IFeature } from "../../api/services/feature.service";

export default function FeatureCombobox({
  features,
  selected,
  setSelected,
}: {
  features: IFeature[];
  selected: IFeature | null;
  setSelected: (user: IFeature) => void;
}) {
  const [query, setQuery] = useState("");

  const filteredPeople =
    query === ""
      ? features
      : features.filter((feature) =>
          feature.name
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""))
        );

  return (
    <Combobox value={selected} onChange={setSelected} nullable multiple>
      <div className="relative">
        <div className="focus:outline-none relative w-full cursor-default overflow-hidden rounded-lg border dark:border-gray-600 bg-white dark:bg-slate-800 text-left focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm">
          <Combobox.Input
            className={`w-full border-none py-2 pl-3 pr-10 bg-white dark:bg-slate-800 text-sm dark:text-gray-200 leading-5 focus:ring-0`}
            placeholder="Invite Email or name of user"
            displayValue={(feature: IFeature) => {
              if (feature) {
                if (feature.id) {
                  return `${feature?.name}`;
                }
              }
              return "";
            }}
            onChange={(event) => setQuery(event.target.value)}
          />
          <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
            <FaChevronDown
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </Combobox.Button>
        </div>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={() => setQuery("")}
        >
          <Combobox.Options className="focus:outline-none absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white dark:bg-slate-900 py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 sm:text-sm">
            {filteredPeople.length === 0 && query.indexOf("@") === -1 && (
              <div className="relative cursor-default select-none py-2 px-4 text-gray-700 dark:text-gray-200">
                Nothing found.
              </div>
            )}
            {filteredPeople.length > 0 &&
              filteredPeople.map((feature) => (
                <Combobox.Option
                  key={feature.id}
                  className={({ active }) =>
                    `relative cursor-default select-none py-2 pl-4 pr-4 ${
                      active
                        ? "bg-indigo-600 text-white"
                        : "text-gray-900 dark:text-gray-100"
                    }`
                  }
                  value={feature}
                >
                  {({ selected, active }) => (
                    <div className="flex items-center">
                      <FaFeather
                        className="w-8 h-8 bg-white rounded-full"
                        color={stringToColor(feature.id)}
                      />
                      <span
                        className={`ml-2 block truncate ${
                          selected ? "font-semibold" : "font-medium"
                        }`}
                      >
                        {feature.name}
                      </span>
                    </div>
                  )}
                </Combobox.Option>
              ))}
          </Combobox.Options>
        </Transition>
      </div>
    </Combobox>
  );
}
